import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'accommodationType',
	pure: true,
	standalone: true,
})
export class AccommodationTypePipe implements PipeTransform {
	transform(
		types: string[] = [],
		params: { isPlural: boolean } = { isPlural: false },
	): string {
		const plural = params.isPlural ? '.plural' : '.singular';

		if (!types?.[0] || types.length !== 1) {
			return 'global.accommodation-types.rooms' + plural;
		}

		return 'global.accommodation-types.' + types[0] + plural;
	}
}
